module.exports = __webpack_public_path__ + "img/img-creater-01.75519be5.svg";